<template>
    <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="center" align="top" :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="NIK">
            <a-input
              autocomplete="off"
              v-decorator="[
                'nik_member',
                { rules: [{ required: true, message: 'NIK is required!' }] }
              ]"
            />
          </a-form-item>

          <a-form-item label="Nama Lengkap">
            <a-input
              autocomplete="off"
              v-decorator="[
                'nama_member',
                { rules: [{ required: true,message: 'Nama Lengkap is required!' }] }
              ]"
            />
          </a-form-item>

          <a-form-item label="Tanggal Lahir">
            <a-date-picker
              class="w-full"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tgl_lahir_member',
                {
                  rules: [{ required: true, message: 'Tanggal Lahir is required!' }]
                }
              ]"
            />
          </a-form-item>

          <a-form-item label="Jenis Kelamin">
            <a-select
              v-decorator="[
                'gender_member',
                { rules: [{ required: true, message: 'Jenis Kelamin is required!' }] }
              ]"
            >
              <a-select-option key="pria" value="laki-laki"
                >Laki - Laki</a-select-option
              >
              <a-select-option key="perempuan" value="perempuan"
                >Perempuan</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item label="Status">
            <a-select
              v-decorator="[
                'status_member',
                { rules: [{ required: true, message: 'Status is required!' }]}
              ]"
            >
              <a-select-option v-for="s in combo_status" :key="s.key" :value="s.name">{{ s.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button v-if="formState == 'create'" style="width: 100%; margin-top: 14px;" type="primary" icon="plus" @click="addMember()">Tambah</a-button>
            <div v-else style="display: flex; flex-direction: row; gap: 12px;">
              <a-button style="width: 50%; margin-top: 14px;" type="secondary" @click="cancelEdit()">Cancel</a-button>
              <a-button style="width: 50%; margin-top: 14px;" type="primary" icon="save" @click="saveEdit()">Simpan</a-button>
            </div>
          </a-form-item>
          
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-table :columns="columns" :data-source="listData" bordered style="margin-top: 10px;"
          :pagination="pagination" 
          :scroll="widthScreen < 400 ? { x: 1200, y:500} : {}"
          :loading="loading.table" size="small"
          key="tblMember" :rowKey="(record, index) => {return index;}"
          >
          <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
          <template slot="nama_member" slot-scope="value, item, index">
            <div style="display: flex; flex-direction: column;">
              <span style="font-weight: bold;">{{ item.nama_member }}</span>
              <span>NIK : {{ item.nik_member }}</span>
              <span>{{ moment(item.tgl_lahir_member).format("DD-MM-YYYY") }} - {{ item.gender_member }}</span>
            </div>
          </template>
          <template slot="keterangan" slot-scope="value, item, index">{{ item.status_member }}</template>
          <template slot="action" slot-scope="value, item, index">
            <div style="display: flex; flex-direction: row; gap: 10px; justify-content: center;"> 
              <a-popconfirm placement="bottomRight" ok-text="Yes" cancel-text="No" @confirm="deleteMember(item)">
                <template slot="title">
                  <p>Are you sure want to delete "{{ item.nama_member }}" ?</p>
                </template>
                <a-button shape="circle" icon="delete" />
              </a-popconfirm>
              <a-button shape="circle" icon="edit" @click="editMember(item)"/>
            </div>
          </template>

          </a-table>
        </a-col>
        
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from "moment-business-days"

const columns = [
    {
        title: 'No',
        width: 40,
        className: 'center',
        scopedSlots: { customRender: 'no' },
    },
    {
        title: 'Nama',
        width: 200,
        dataIndex: 'nama_member',
        scopedSlots: { customRender: 'nama_member' },
    },
    {
        title: 'Keterangan',
        dataIndex: 'keterangan',
        className: 'center',
        scopedSlots: { customRender: 'keterangan' },
    },
    {
        title: 'Action',
        className: 'center',
        scopedSlots: { customRender: 'action' },
    },
];
const combo_status = [
    { key: "istri", name: "Istri" },
    { key: "suami", name: "Suami" },
    { key: "anak1", name: "Anak 1" },
    { key: "anak2", name: "Anak 2" },
    { key: "anak3", name: "Anak 3" },
    { key: "anak4", name: "Anak 4" },
    { key: "anak5", name: "Anak 5" },
    { key: "anak6", name: "Anak 6" },
    { key: "anak7", name: "Anak 7" },
    { key: "anak8", name: "Anak 8" },
    { key: "anak9", name: "Anak 9" }
];

export default {
    name: "member",
    props: ["data", "mode"],
    data(){
      return{
        listData: [],
        loading: {
            table: false
        },
        moment,
        columns,
        combo_status,
        pagination: {},
        widthScreen: 0,
        heighScreen: 0,
        formState: 'create',
        editId: 0
      }
    },

    computed: {
        ...mapGetters(["getDefaultDateFormat", "getMaster"])
    },

    mounted(){
        this.widthScreen = window.innerWidth
        this.heighScreen = window.innerHeight
    },

    beforeCreate(){
        this.form = this.$form.createForm(this);
    },

    methods: {
      addMember(){
        this.form.validateFields( async (err, values) => {
          console.log(values);
          if(err){
            this.displayMessage("form-warning");
            return;
          }

          const items = {  
            nik_member: values.nik_member,
            nama_member: values.nama_member,
            tgl_lahir_member: moment(values.tgl_lahir_member).format("YYYY-MM-DD"),
            gender_member: values.gender_member,
            status_member: values.status_member
          }

          this.listData.push({...items})
          this.displayMessageValue("success-basic", "Data member berhasil ditambahkan");
          this.form.resetFields()
          
        })
      },

      saveEdit(){
        try {
          this.form.validateFields( async (err, values) => {
            if(err){
              this.displayMessage("form-warning");
              return;
            }

            const item = this.listData.find((d) => d.nik_member == this.editId)
            if(item){
              item.nik_member = values.nik_member
              item.nama_member = values.nama_member
              item.tgl_lahir_member = moment(values.tgl_lahir_member).format("YYYY-MM-DD")
              item.gender_member = values.gender_member
              item.status_member = values.status_member
            }
            this.displayMessageValue("success-basic", "Data member berhasil diubah");
            this.form.resetFields()
          })
        } catch (error) {
          console.log(error);
        }
        this.formState = 'create'
      },

      cancelEdit(){
        this.formState = 'create'
        this.form.resetFields()
      },

      deleteMember(values){
        const new_arr = this.listData.filter((d) => d.nik_member !== values.nik_member)
        this.listData = new_arr
        this.displayMessageValue("success-basic", "Data member berhasil dihapus");
      },

      editMember(values){
        this.formState = 'edit'
        this.editId = values.nik_member
        this.form.setFieldsValue({
          nik_member: values.nik_member,
          nama_member: values.nama_member,
          tgl_lahir_member: moment(values.tgl_lahir_member).format("YYYY-MM-DD"),
          gender_member: values.gender_member,
          status_member: values.status_member
        })
      },

      handleRef(){
        // if(this.listData.length == 0){
        //   this.displayMessage("form-warning");
        //   return
        // }
        Event.$emit("createKaryawan", this.listData);
      }

    }
}

</script>